import { render, staticRenderFns } from "./PriceSettings.vue?vue&type=template&id=6217c0f9&scoped=true&"
import script from "./PriceSettings.vue?vue&type=script&lang=js&"
export * from "./PriceSettings.vue?vue&type=script&lang=js&"
import style0 from "./PriceSettings.vue?vue&type=style&index=0&id=6217c0f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6217c0f9",
  null
  
)

export default component.exports